import React from 'react';

import { Row } from '~components/table-view';

import { renderRegisteredServiceStatusBadge } from '~support-at-home/components/proda/SahRegisteredServicesCells';

// TAV-3234 (AC5). Blank unless this service actually has a Services Australia registration. The
// badge itself is the Registered Services tab's own renderer, called with the registration row the
// API matched, so both screens say the same thing about the same registration by construction.
const RegistrationBadge: React.FC<{ row: Row }> = ({ row }) => {
  const registration = row?.registration;
  if (!registration) return null;
  return <>{renderRegisteredServiceStatusBadge(undefined, registration)}</>;
};

export default RegistrationBadge;
